import { useState, useEffect } from "react";
//@ts-ignore
import ActionCable from "actioncable";
import Datasource from "lib/datasource";
import moment from "moment";
import { getAuthTokenFromCookie ,getUserIdFromStorage } from 'lib/hooks';
import axiosServices from "v2/utils/axios";

export const getUserInfo = (session: any) => {
	return {
		id: session.id,
		admin: session.admin,
		email: session.email,
		firstname: session.firstname,
		surname: session.surname,
		features: JSON.parse(session.features? session.features : []),
		phone_number: session.phone_number
	};
};

export const useCreateCable = () => {
	const [cable, setCable] = useState<any>();
	const [error, setError] = useState<any>();
	const [, renderTrigger] = useState(moment());
	const [datasource] = useState(
		new Datasource({
			mainModelName: "userInfo",
			renderTrigger: renderTrigger
		})
	);

	useEffect(() => {
		try {
			const token = datasource.getAuthTokenFromCookie();
			const cable = ActionCable.createConsumer(
				`${process.env.REACT_APP_WEBSOCKET}cable?accessToken=${token}`
			)
			setCable(cable)
		} catch (error) {
			setError(error)
		}
	}, [datasource]);
	return [cable, error];
};

interface JwtPayload {
	id: string;
	admin?: boolean;
	email?: string;
	firstname?: string;
	surname?: string;
	features?: string[];
	phone_number?: string;
	exp: number; // standard JWT field
	iat: number; // standard JWT field
}  


export const useCurrentUserInfo = () => {
	const [currentUser, setCurrentUser] = useState<any>();
	const [error, setError] = useState<any>();

	useEffect(() => {
		const userId = getUserIdFromStorage();
		const token = getAuthTokenFromCookie();
		if (!userId || !token) {
			setError('No auth token or User id');
			return;
		}

		// Call the API directly rather than going through Datasource. The
		// /v2/users/:id endpoint returns a plain `{ user: {...} }` payload, not
		// JSON:API (no top-level `data` field), and the Datasource's
		// jsonapi-normalizer throws on that shape. The throw is swallowed and
		// surfaced as `success: false`, which makes ProtectedRoute redirect
		// back to /signin after a successful login.
		let cancelled = false;
		axiosServices.get(`users/${userId}`)
			.then((response: any) => {
				if (cancelled) return;
				const user = response?.data?.user;
				if (user && user.id) {
					setCurrentUser(user);
					localStorage.setItem('user', JSON.stringify(user));
				} else {
					setCurrentUser({});
					setError('Could not get user info');
				}
			})
			.catch(() => {
				if (cancelled) return;
				setCurrentUser({});
				setError('Could not get user info');
			});

		return () => { cancelled = true; };
	}, []);

	return [currentUser, error];
};
